import { Fragment } from 'react';
import { ManageCredit } from './ManageCredit';
import { Drawer } from '@/components';
import { ManageCreditActions } from './ManageCreditActions';

type ManageCreditDrawerProps = {
  value: boolean;
  setFalse: () => void;
};

export const ManageCreditDrawer = (props: ManageCreditDrawerProps) => {
  const { value, setFalse } = props;

  return (
    <Fragment>
      <Drawer
        open={value}
        onClose={setFalse}
        title={'Manage Credit'}
        content={<ManageCredit />}
        actions={<ManageCreditActions onClose={setFalse} />}
      />
    </Fragment>
  );
};
